import {
  AppDataComponent,
  BuilderComponent,
} from '@wix/document-services-types';
import { Breakpoint } from '@wix/editor-platform-host-integration-apis';
import {
  ComponentType,
  PresetItem,
} from '@wix/ambassador-devcenter-components-v1-component/types';
import { PlatformContext } from '../../../types/platformApi';

export type BuilderPreset = PresetItem & {
  id: string;
};

export const isBuilderComponent = (
  component: AppDataComponent,
): component is BuilderComponent =>
  Boolean(component && component.type === ComponentType.EDITOR_REACT_COMPONENT);

export const builderPresetsMapper = (
  presets: Record<string, PresetItem>,
): BuilderPreset[] =>
  Object.entries(presets).map(([key, preset]) => ({
    ...preset,
    id: key,
  }));

export const sortPresets = (
  presets: BuilderPreset[],
  componentType: string,
  currentBreakpoint: Breakpoint,
  context: PlatformContext,
) => {
  const installationPresets =
    context.componentsPlatformService.manifest.getInstallationByComponentType(
      componentType,
    )?.presets;

  if (!installationPresets) {
    return [...presets];
  }

  const presetId =
    installationPresets[currentBreakpoint] ??
    installationPresets.default ??
    installationPresets.large;

  if (presetId) {
    const installationPreset = presets.find((p) => p.id === presetId);
    const rest = presets.filter((p) => p.id !== presetId);

    if (installationPreset) {
      return [installationPreset, ...rest];
    }
  }

  return [...presets];
};
